module.exports = __webpack_public_path__ + "static/media/Gard-Cabernet-Sauv.fd08c7d0.jpg";